
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const mfSeriesFaderPack: IProductData = {
  id: "purple-audio-fader",
  name: "Purple Audio MF Series Fader Pack",
  description: "A 4RU Fader Unit",
  specialOrder: true,
  images: ["/img/purpleaudio_fader_front.jpg", "/img/purpleaudio_fader_back.jpg"],
  details: [{
    label: "Description",
    markdown: `
The MF Series Fader Pack is a great solution for any studio environment.  
The MF Series Fader Pack comes in a few configurations, each to accomplish a unique task in your workflow.  
Fader connect to the MFTwenty5 fader loop connector.   
Faders are also available as a standalone unit but not the fader loops are unbalanced and so care must be taken connecting.   
We use TKD 9000 series faders, a quality fader available in mono and stereo versions.
`
  }, {
    label: "Varieties",
    markdown: `
FTen – Ten mono faders. 
FTen2 – Ten mono faders, one Stereo master fader.  
FTwenty – Ten Stere0 faders.  
FTwenty2 – Eleven Stereo Faders, Ten for inputs, one master fader.  
` 
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://purpleaudio.com/products/mf-twenty-25/" target="_blank">https://purpleaudio.com/products/mf-twenty-25/</a>
    `
  }],
  metadata: {
    hashtags: [HASHTAGS.MIXING, HASHTAGS.LIVE_SOUND, HASHTAGS.MASTERING],
    manufacturer: BRAND.PURPLE_AUDIO,
  },
  videos: []
}